module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"dropdown\"> <button id=\"dLabel\" class=\"btn btn-sm btn-default\" data-toggle=\"dropdown\" role=\"button\"> ")
    ; __append(escapeFn( locals.currentChoice.readable ))
    ; __append(" <span class=\"caret\"></span> </button> <ul class=\"dropdown-menu\"> ")
    ;  _(locals.choices).each(function(choice) { 
    ; __append(" <li> <a data-option=\"")
    ; __append(escapeFn( choice.option ))
    ; __append("\" href=\"\">")
    ; __append(escapeFn( choice.readable ))
    ; __append("</a> </li> ")
    ;  }); 
    ; __append(" </ul> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/selector.ejs
// module id = 868
// module chunks = 1